(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nirobi-blog-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealArticles = (section, focusFirst = false) => {
      section.classList.remove('nirobi-editorial--mobile-collapsed');
      const button = section.querySelector('.nirobi-editorial__more');
      button.setAttribute('aria-expanded', 'true');
      if (focusFirst) section.querySelectorAll('.nirobi-editorial__card')[3]?.querySelector('a')?.focus();
      button.hidden = true;
    };
    const initialiseEditorials = (root = document) => {
      root.querySelectorAll('.nirobi-editorial').forEach(section => {
        const button = section.querySelector('.nirobi-editorial__more');
        if (!button || button.dataset.initialised || section.querySelectorAll('.nirobi-editorial__card').length <= 3) return;
        button.dataset.initialised = 'true';
        section.classList.add('nirobi-editorial--mobile-collapsed');
        button.hidden = false;
        button.addEventListener('click', () => revealArticles(section, true));
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseEditorials(), { once: true });
    } else {
      initialiseEditorials();
    }
    document.addEventListener('shopify:section:load', event => initialiseEditorials(event.target));
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('.nirobi-editorial__card');
      const section = card?.closest('.nirobi-editorial--mobile-collapsed');
      if (section && [...section.querySelectorAll('.nirobi-editorial__card')].indexOf(card) >= 3) revealArticles(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nirobi-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nirobi-customer-reviews')) {
    customElements.define('nirobi-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._controller = new AbortController();
        this._track = this.querySelector('[data-review-track]');
        this._cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this._controls = this.querySelector('[data-review-controls]');
        this._previous = this.querySelector('[data-review-previous]');
        this._next = this.querySelector('[data-review-next]');
        this._count = this.querySelector('[data-review-count]');
        this._status = this.querySelector('[data-review-status]');
        this._index = 0;
        this._visibleCount = 1;
        this._maxIndex = 0;
        this._layoutWidth = 0;
        if (!this._track || !this._cards.length) return;

        const signal = this._controller.signal;
        this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._previous?.addEventListener('click', () => this.goTo(this._index - 1), { signal });
        this._next?.addEventListener('click', () => this.goTo(this._index + 1), { signal });
        this._track.addEventListener('scroll', () => {
          window.clearTimeout(this._scrollTimer);
          this._scrollTimer = window.setTimeout(() => this.syncPosition(), 120);
        }, { signal, passive: true });
        this._track.addEventListener('keydown', (event) => {
          if (event.target !== this._track || !this._hasOverflow) return;
          const rtl = getComputedStyle(this._track).direction === 'rtl';
          let index;
          if (event.key === 'ArrowRight') index = this._index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') index = this._index + (rtl ? 1 : -1);
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this._maxIndex;
          if (index === undefined) return;
          event.preventDefault();
          this.goTo(index);
        }, { signal });
        this._resizeObserver = new ResizeObserver(() => this.syncLayout());
        this._resizeObserver.observe(this._track);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this._cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.goTo(index, true);
        }, { signal });
        this.dataset.enhanced = '';
        this.syncLayout();
      }

      disconnectedCallback() {
        this._controller?.abort();
        this._resizeObserver?.disconnect();
        window.clearTimeout(this._scrollTimer);
        this._connected = false;
      }

      syncLayout() {
        const width = this._track.clientWidth;
        if (!width) return;
        const columns = parseInt(getComputedStyle(this._track).getPropertyValue('--nr-columns'), 10) || 1;
        const visibleCount = Math.min(columns, this._cards.length);
        const layoutChanged = width !== this._layoutWidth || visibleCount !== this._visibleCount;
        this._layoutWidth = width;
        this._visibleCount = visibleCount;
        this._maxIndex = Math.max(0, this._cards.length - visibleCount);
        this._hasOverflow = this._track.scrollWidth > width + 1;
        if (this._controls) this._controls.hidden = !this._hasOverflow;
        if (this._hasOverflow) {
          this._track.setAttribute('tabindex', '0');
        } else {
          this._track.removeAttribute('tabindex');
        }
        if (layoutChanged) this.goTo(this._index, true, false);
        this.syncPosition(false);
      }

      syncPosition(announce = true) {
        const trackRect = this._track.getBoundingClientRect();
        const rtl = getComputedStyle(this._track).direction === 'rtl';
        let closestIndex = 0;
        let closestDistance = Infinity;
        this._cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs(rtl ? rect.right - trackRect.right : rect.left - trackRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        const nextIndex = Math.min(closestIndex, this._maxIndex);
        const changed = nextIndex !== this._index;
        this._index = nextIndex;
        this.updateControls(announce && changed);
      }

      goTo(index, immediately = false, announce = true) {
        const nextIndex = Math.max(0, Math.min(index, this._maxIndex));
        const cardRect = this._cards[nextIndex].getBoundingClientRect();
        const trackRect = this._track.getBoundingClientRect();
        const rtl = getComputedStyle(this._track).direction === 'rtl';
        const offset = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
        this._index = nextIndex;
        this._track.scrollTo({
          left: this._track.scrollLeft + offset,
          behavior: immediately || this._reducedMotion.matches ? 'instant' : 'smooth'
        });
        this.updateControls(announce);
      }

      updateControls(announce) {
        if (!this._controls) return;
        this._previous.disabled = this._index === 0;
        this._next.disabled = this._index >= this._maxIndex;
        const first = this._index + 1;
        const last = Math.min(this._index + this._visibleCount, this._cards.length);
        this._count.textContent = `${first} / ${this._maxIndex + 1}`;
        if (announce) this._status.textContent = first === last
          ? `Review ${first} of ${this._cards.length}`
          : `Reviews ${first} to ${last} of ${this._cards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
